// admin.jsx:1032 fmt: `d => d ? d.split('-').reverse().join('/') : '—'` sobre
// `mf.est`/`mf.real` al *guardar* un registro nuevo, y admin.jsx:951 para
// `acquiredOn` de vehículo (`12 mar 2024`) — mismo criterio de presentación
// en ambos lugares del baseline: día con cero a la izquierda, abreviatura de
// mes de tres letras, año completo.
//
// `Intl.DateTimeFormat("es-EC", { month: "short" })` da "sept" (cuatro
// letras) para septiembre en el motor ICU de este entorno — el baseline
// siempre usa tres. Tabla fija en vez de depender de qué abreviatura elija
// ese motor.
//
// Movido a `src/core` (SPEC-207, PLAN-009 §7.4) desde
// `portal/features/vehicles/dateFormat.ts`: `portal.scheduling` también lo
// necesita (para `onDate` y `createdAt` de las excepciones) y un `import`
// entre dos features del portal es el acoplamiento que `web-portal.md`
// prohíbe. `vehicles/dateFormat.ts` queda como reexport de una línea para no
// tocar sus dos consumidores más de lo necesario en sus imports.
const monthsEs = [
  "ene",
  "feb",
  "mar",
  "abr",
  "may",
  "jun",
  "jul",
  "ago",
  "sep",
  "oct",
  "nov",
  "dic",
];

// Acepta tanto `YYYY-MM-DD` (fecha pura, sin hora, como `acquiredOn` o
// `onDate`) como un ISO con hora (`createdAt`, date-time): en ambos casos
// solo importan los primeros 10 caracteres, y se construye la fecha local
// a partir de ellos para no correr el riesgo de que el desplazamiento de
// huso mueva el día mostrado.
export const formatShortDate = (value?: string | null): string => {
  if (!value) return "—";
  const datePart = value.slice(0, 10);
  const date = new Date(`${datePart}T00:00:00`);
  if (Number.isNaN(date.getTime())) return "—";
  const day = String(date.getDate()).padStart(2, "0");
  return `${day} ${monthsEs[date.getMonth()]} ${date.getFullYear()}`;
};
